import { ActivityProperties } from '../activity-base.model';

export type ActivityStairwellsProperties = ActivityProperties<
  Record<
    'apartments_per_stairwell_per_storey' | 'elevators_per_stairwell',
    number
  >
>;

export const defaultStairwellsProperties: ActivityStairwellsProperties = {
  apartments_per_stairwell_per_storey: 4,
  elevators_per_stairwell: 1,
};
